import {SvgIcon} from "@mui/material";

export default function CircleIcon(){
    return(
        <SvgIcon width={"34"} height={"34"} viewBox={"0 0 34 34"} fill={"none"}>
            <path fillRule="evenodd" clipRule="evenodd" d="M17 29.5C23.9036 29.5 29.5 23.9036 29.5 17C29.5 10.0965 23.9036 4.50004 17 4.50004C10.0965 4.50004 4.50001 10.0965 4.50001 17C4.50001 23.9036 10.0965 29.5 17 29.5ZM17 33.6667C26.2048 33.6667 33.6667 26.2048 33.6667 17C33.6667 7.7953 26.2048 0.333374 17 0.333374C7.79527 0.333374 0.333344 7.7953 0.333344 17C0.333344 26.2048 7.79527 33.6667 17 33.6667Z" fill="white"/>
        </SvgIcon>
    )
}